module.exports = __webpack_public_path__ + "static/img/bg-1.512a0bf7.png";